export enum LoginTypeEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
  CLASSIC = 'CLASSIC',
  FACEBOOK = 'FACEBOOK',
  PIM = 'PIM',
}
